// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"y6-z","sponsoredTooltipWrapper":"z6-z","sponsoredTooltip":"A6-z","newCard":"B6-z"};